import cn from 'clsx'

import { MultiSelect } from '@App/ui/crypto_exchange/desktop/components/controls/MultiSelect'

import { Select } from '../../../../../SpotOrderTrade/components/Select'
import {
  REPORT_STATUS_OPTIONS,
  REPORT_TYPE_OPTIONS,
  ReportsFilter,
  ReportsFilters,
  TIME_PERIOD_OPTIONS,
} from '../../../../model'

import s from './styles.module.scss'
import { ReactNode } from 'react'

export const Filters = ({
  filters,
  setFilter,
  enabledFilters,
  reportButton,
}: {
  enabledFilters?: ReportsFilters[]
  filters: ReportsFilter
  setFilter: <K extends keyof ReportsFilter>(key: K, val: ReportsFilter[K]) => void
  reportButton?: ReactNode
}) => {
  const filtersVisitility = {
    [ReportsFilters.Period]: enabledFilters ? enabledFilters?.some((v) => v === ReportsFilters.Period) : true,
    [ReportsFilters.Status]: enabledFilters ? enabledFilters?.some((v) => v === ReportsFilters.Status) : true,
    [ReportsFilters.Type]: enabledFilters ? enabledFilters?.some((v) => v === ReportsFilters.Type) : true,
  }
  return (
    <div className={s.filters}>
      {filtersVisitility[ReportsFilters.Status] && (
        <MultiSelect
          value={filters.status}
          options={REPORT_STATUS_OPTIONS}
          containerClassName={s.periodSelectContainer}
          onChange={(val) => {
            setFilter(ReportsFilters.Status, val)
          }}
          placeholder="Status"
        />
      )}
      {filtersVisitility[ReportsFilters.Type] && (
        <MultiSelect
          value={filters.type}
          options={REPORT_TYPE_OPTIONS}
          containerClassName={s.periodSelectContainer}
          onChange={(val) => {
            setFilter(ReportsFilters.Type, val)
          }}
          placeholder="Type"
        />
      )}
      {filtersVisitility[ReportsFilters.Period] && (
        <Select
          value={filters.period}
          options={TIME_PERIOD_OPTIONS}
          containerClassName={s.periodSelectContainer}
          onChange={(val) => {
            setFilter(ReportsFilters.Period, val as string)
          }}
          placeholder="Period"
        />
      )}
      {reportButton}
    </div>
  )
}
